export function decodeBase64Value(base64String: string) {
    try {
        const decodedString = atob(base64String)
        const parsedData = JSON.parse(decodedString)
        return parsedData
    } catch (error) {
        console.error("Error decoding base64:", error)
        return base64String
    }
}
